<template>
	<div class="c-people-tile">
		<a
			:href="item.url"
			class="c-people-tile__image-link">
			<div class="c-people-tile__image-container">
				<picture v-if="item.image && item.image.cropUrl">
					<source
						:srcset="item.image.cropUrl + '?format=webp'"
						type="image/webp" />
					<img
						class="c-people-tile__image"
						:src="item.image.cropUrl"
						loading="lazy"
						:alt="item.image.altText" />
				</picture>

				<img
					v-else
					class="c-people-tile__image c-people-tile__image-placeholder"
					src="/Content/images/interface/logo/buddlefindlay-logo.svg"
					:alt="item.title" />
			</div>
		</a>
		<div
			class="c-people-tile__name"
			v-html="formatTitle(item.title.value)"></div>
		<div
			class="c-people-tile__position"
			v-if="item.categories">
			<div
				class="c-people-tile__category">
				<span
					v-for="(category, index) in item.categories"
					v-bind:key="category.id">
					{{ category.name }}{{ index < item.categories.length - 1 ? ", " : "" }}
				</span>
			</div>
			<div
				class="c-people-tile__role"
				v-if="item.roleFreeText">
				{{ item.roleFreeText }}
			</div>
		</div>
		<div
			class="c-people-tile__bio"
			v-if="toggleBio">
			{{ item.abstract }}
		</div>
		<div
			class="c-people-tile__contact"
			v-if="toggleContact">
			<div
				v-if="item.phone"
				class="c-people-tile__contact-item c-people-tile__contact-item">
				DDI <a :href="'tel:' + item.phone">{{ item.phone }}</a>
			</div>
			<div
				v-if="item.mobile"
				class="c-people-tile__contact-item">
				M <a :href="'tel:' + item.mobile">{{ item.mobile }}</a>
			</div>
		</div>
		<div
			v-if="item.email && toggleContact"
			class="c-people-tile__button-wrapper">
			<a
				class="c-people-tile__button"
				:href="'mailto:' + item.email"
				>Email</a
			>
		</div>
	</div>
</template>

<script setup>
	import { computed } from "vue";
	import { formatCaretToSpan } from "Util/text-formatter";

	const props = defineProps({
		item: Object,
		toggleBio: { type: Boolean, default: true },
		toggleContact: { type: Boolean, default: true }
	});

	const toggleBio = computed(() => props.toggleBio !== false);
	const toggleContact = computed(() => props.toggleContact !== false);

	function formatTitle(text) {
		return formatCaretToSpan(text);
	}
</script>
